import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LanguageNavbarComponent } from "./language-navbar.component";
import { NgZorroAntdModule } from "src/app/modules/nz-zorro-antd.module";
import { NgZorroIconModule } from "src/app/modules/nz-icon-antd.module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule( {
	declarations: [ LanguageNavbarComponent ],
	imports: [ CommonModule, TranslateModule, NgZorroAntdModule, NgZorroIconModule ],
	exports: [ LanguageNavbarComponent ]
} )
export class LanguageNavbarModule {}
